import { useLocation, useParams } from 'react-router-dom'
import useSWR from 'swr'

import { DirectTask } from '@frame/lib/api/tasks/types'

import { useRootContext } from '../context'

export function useDirectTask(refresh = false): DirectTask | undefined {
  const location = useLocation()
  // TODO: Rely on root context for this in the future? Implementation is looking a lot like redux at this point, might be helpful to adopt that tool
  const task = location.state?.task
  const { taskId = '' } = useParams()
  const { api } = useRootContext()

  const itemId = new URLSearchParams(location.search).get('item_id')

  const { data } = useSWR(['all', 'tasks'], api.tasks.getAllDirectTasks, {
    revalidateOnFocus: false,
    keepPreviousData: true,
    revalidateOnMount: false,
  })

  if (task && !refresh) {
    return task
  }

  if (itemId) {
    return data?.data?.find((e) => e.id === taskId && e.connector_company_identifier === itemId)
  }

  return data?.data?.find((e) => e.id === taskId)
}
